import Pristine from 'pristinejs';

import { createXHR, PristineConfig, showOverlay } from './utils';

const init = () => {
  document.querySelectorAll('.js-newsletter-btn').forEach(el => el.addEventListener('click', openOverlay));
  const newsletterForm = document.getElementById('newsletter-form');
  setupForm(newsletterForm);
}

const openOverlay = event => {
  if(event) { event.preventDefault(); }
  showOverlay('newsletter-overlay');
}


const setupForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const pristine = new Pristine(form, PristineConfig);
    const isValid = pristine.validate();

    if (!isValid) {
      console.log(pristine.getErrors(), 'form is NOT valid');
      return;
    }
    // send form
    sendRequest(form, pristine);
  });
}

const sendRequest = (form, pristine) => {
  // Collect the form data while iterating over the inputs
  const formData = new FormData(form);
  const data = {
    email: formData.get('email'),
    first_name: formData.get('first_name'),
    genres: formData.getAll('genres'),
    instruments: formData.getAll('instruments'),
    last_name: formData.get('last_name'),
    url: document.location.href,
  };

  const xhr = createXHR({
    method: 'POST',
    endpoint: '/api/v2/user/newsletter/subscribe',
    data
  });

  xhr.onload = () => {
    switch (xhr.status) {
      case 200:
        subscribeSuccess(form);
        break;
      case 422:
        parseErrors(form, JSON.parse(xhr.responseText), pristine);
        break;
      default:
        console.log('unknown status', xhr.status);
        break;
    }
  };
}

// Parse server errors and display with relevant input field
const parseErrors = (form, data, pristine) => {
  if(data.hasOwnProperty('message')) {
    for (let i = 0; i < form.length; i++) {
      const input = form[i];
      if(data.message.hasOwnProperty(input.name)) {
        // cycle through errors, checking for custom messages
        data.message[input.name].forEach(error =>
          pristine.addError(input, input.dataset[`${error}Message`] ? input.dataset[`${error}Message`] : error));
      }
    }
  }
  form.querySelector('button[type="submit"]').disabled = false;
}


const subscribeSuccess = (form) => {
  // TODO: display success message
  console.log('Subscribe success');
  form.reset();
  document.querySelectorAll('.o-overlay').forEach(el => el.classList.add('is-hidden'));
}

export default {init, openOverlay};
